/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取验证码场景
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: dictionary.AliyunCaptchaType;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/dictionary/captcha/type`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
